import { Inject, Injectable, Optional } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AUTOCLOSE_LISTENERS } from '@shared/components/listeners';
import { PlatformAppContext } from '@/app/platform/platform-context/platform-app-context';
import { NGXLogger } from 'ngx-logger';
import { Listener } from '@/types/listener.types';

@Injectable({
  providedIn: 'root'
})
export class CloseListenersGuard  {
  constructor(
    @Optional()
    @Inject(AUTOCLOSE_LISTENERS)
    private readonly signalRHubListeners: Listener[] | null,
    private readonly appContext: PlatformAppContext,
    private readonly logger: NGXLogger
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    await this.closeAllListeners(route);
    return true;
  }

  async canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    await this.closeAllListeners(childRoute);
    return true;
  }

  private async closeAllListeners(route: ActivatedRouteSnapshot) {
    if (this.shouldResetConnections(route)) {
      for (const listener of this.signalRHubListeners ?? []) {
        if (listener.isAvailable) {
          this.logger.info(`Closing listener with name ${listener.name}`);
          await listener.close();
        }
      }
    }
  }

  private shouldResetConnections(route: ActivatedRouteSnapshot) {
    const previousRoute = JSON.stringify(this.appContext.activeNavigationItem?.egiPage.config);
    const nextRoute = JSON.stringify(route.data.config);

    return previousRoute && nextRoute && previousRoute !== nextRoute;
  }
}
